// src/pages/beta-community/components/PlansSection.jsx
import React from 'react';

const PlansSection = ({ scrollToSection }) => {
  const plans = [
    {
      name: 'Collectionneur Standard',
      description: 'Pour structurer une première collection privée',
      value: '174€',
      features: [
        'Inventaire œuvres illimité',
        'Fiches techniques et photos',
        'Géolocalisation et documents',
        'Exports PDF / CSV',
        '1 collaborateur en lecture'
      ],
      isFeatured: false
    },
    {
      name: 'Collectionneur Premium',
      description: 'Pour une collection active avec IA, experts et transmission',
      value: '1.194€',
      features: [
        'Vision IA selon modules disponibles',
        'Valorisation et conservation assistées',
        'Invitation experts et permissions',
        'Matching successoral',
        '5 collaborateurs + droits granulaires'
      ],
      isFeatured: false
    },
    {
      name: 'Art Advisor',
      description: 'Pour gérer jusqu’à 20 clients avec un espace professionnel',
      value: '594€',
      features: [
        'Dashboard multi-clients',
        'Collections partagées par mandat',
        'Consultation des rapports IA clients Premium',
        'Lots, CUP et rapports de valorisation',
        'Profil professionnel Artkiv'
      ],
      isFeatured: true,
      badge: 'Pro'
    },
    {
      name: 'Art Advisor Premium',
      description: 'Pour lancer les analyses et gérer un portefeuille illimité',
      value: '1.194€',
      features: [
        'Clients illimités',
        'Lancement IA pour tous les clients',
        'Lecture curatoriale accessible',
        'Rapports personnalisés à votre image',
        'Facturation et suivi professionnel'
      ],
      isFeatured: true,
      badge: 'Recommandé'
    },
    {
      name: 'Family Office / CGP',
      description: 'Pour superviser plusieurs familles ou portefeuilles patrimoniaux',
      value: '1.794€',
      features: [
        'Vue consolidée multi-familles',
        'Reporting patrimonial art',
        'Confidentialité entre familles',
        'Export consolidé',
        'Outils transmission et assurance'
      ],
      isFeatured: false
    }
  ];

  return (
    <section id="plans" className="section plans-section">
      <div className="container">
        <h2 className="section-title">Choisissez votre parcours bêta</h2>
        <p className="section-intro">
          La Beta Community n’est pas une offre unique : elle permet de tester ARTKIV selon votre usage réel, collection privée, conseil en art ou supervision patrimoniale.
        </p>
        
        <div className="plans-container">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`plan-card ${plan.isFeatured ? 'featured' : ''}`}
            >
              {plan.badge && <div className="plan-badge">{plan.badge}</div>}
              
              <h3 className="plan-name">{plan.name}</h3>
              <p className="plan-desc">{plan.description}</p>
              
              <p className="plan-value-label">Valeur de 6 mois bêta :</p>
              <div className="plan-value-amount">{plan.value}</div>
              
              <div className="plan-features">
                {plan.features.map((feature, idx) => (
                  <div key={idx} className="plan-feature">
                    {feature}
                  </div>
                ))}
              </div>
              
              <button
                className={`btn ${plan.isFeatured ? 'btn-primary' : 'btn-secondary'}`}
                onClick={() => scrollToSection('inscription')}
              >
                Rejoindre
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlansSection;
